export enum MetadataCompareOperator {
  Undefined = "Undefined",
  Equals = "Equals",
  NotEquals = "NotEquals",
  GreatherThan = "GreatherThan",
  LowerThan = "LowerThan",
  Exists = "Exists",
  NotExists = "NotExists",
}
